import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import resources from './assets/locales/translation.json';

declare module 'i18next' {
    interface CustomTypeOptions {
        returnNull: false;
    }
}

i18n.use(initReactI18next) // passes i18n down to react-i18next
    .init({
        debug: false,
        lng: 'en',
        fallbackLng: 'en',
        returnNull: false,
        resources,
        keySeparator: false, // we do not use keys in form messages.welcome
        interpolation: {
            escapeValue: false, // react already safes from xss
        },
    });

export default i18n;
